export default __webpack_public_path__ + "static/media/mongodb.95ebe78c.png";